import React from 'react';
import { NSCard } from 'bricks';
import classNames from 'classnames';

export type IProps = {
    title?: string;
    subtitle?: string;
    children?: React.ReactNode;
    className?: string;
    titleClassName?: string;
};

const EmptyState = ({
    title, subtitle, children, className, titleClassName,
}: IProps) => (
    <NSCard className={classNames('emptyState d-flex flex-column justify-content-center align-items-center', className)}>
        <h3 className={classNames('emptyState__title mb-1', titleClassName || 'text-white')}>{title}</h3>
        <p className="emptyState__description mt-0 mb-2 text-muted">{subtitle}</p>
        {children}
    </NSCard>
);

export default EmptyState;
